import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "antd";
import { DeploymentUnitOutlined } from "@ant-design/icons";
import ReportDom from "../../../components/common/ReportDom";
import ErrorBoundary from "../../../components/common/ErrorBoundary";
import SalesVoucherBody from "./SalesVoucherBody";
import WorkflowDrawer from "../../Workflow/WorkflowDrawer";

export default function PrintSalesVoucher() {
  const { sale_id } = useParams();
  const [ready, setReady] = useState(false);
  const [wfOpen, setWfOpen] = useState(false);

  useEffect(() => {
    // preload any required lookup data here
    setReady(true);
  }, []);

  if (!ready) return null;

  return (
    <div style={{ background: "#fff", padding: 0 }}>
      {/* Workflow action — hidden when printing */}
      <style>{`@media print { .wf-no-print { display: none !important; } }`}</style>
      <div className="wf-no-print" style={{ display: "flex", justifyContent: "flex-end", padding: "8px 16px" }}>
        <Button type="primary" ghost icon={<DeploymentUnitOutlined />} onClick={() => setWfOpen(true)}>
          Workflow
        </Button>
      </div>

      <ErrorBoundary message="This invoice could not be loaded.">
        <ReportDom
          renderTable={() => (
            <SalesVoucherBody
              sale_id={sale_id}
              printMode
              showStamp
              showSignature
            />
          )}
        />
      </ErrorBoundary>

      <WorkflowDrawer
        recordType="sales"
        recordId={sale_id}
        open={wfOpen}
        onClose={() => setWfOpen(false)}
        title={`Workflow — Invoice ${String(sale_id || "").slice(0, 8)}…`}
      />
    </div>
  );
}
